import _typeof from "@babel/runtime/helpers/typeof";

/**
 * @file clone Clone an JavaScript object.
 * @author yuzong(yuzong@tencent.com)
 */
import { getUniqueKey } from './getUniqueKey';
/**
 * Clone an JavaScript object.
 *
 * @param obj The object that need to be cloned.
 * @param circularReferenceSafe Set `true` when obj has circular reference.
 * @return The cloned object.
 */

export function clone(obj) {
  var circularReferenceSafe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (obj == null || _typeof(obj) !== 'object') {
    return obj;
  }

  var target = Array.isArray(obj) ? [] : {};
  var targetList = [target];
  var originList = [obj];
  var visited = {};

  var _loop = function _loop() {
    var data = originList.pop();
    var target = targetList.pop();
    circularReferenceSafe && (visited[getUniqueKey(data)] = data);
    Object.keys(data).forEach(function (k) {
      if (data[k] == null || _typeof(data[k]) !== 'object') {
        target[k] = data[k];
        return;
      }

      if (circularReferenceSafe && visited[getUniqueKey(data[k])]) {
        target[k] = visited[getUniqueKey(data[k])];
        return;
      }

      targetList.push(target[k] = Array.isArray(data[k]) ? [] : {});
      originList.push(data[k]);
    });
  };

  while (originList.length) {
    _loop();
  }

  return target;
}